import { call, takeEvery, put } from 'redux-saga/effects';
import * as feedbackActions from '../actions/feedback';
import { sendMessageRequest } from '../../api/feedback/sendMessageRequest';
import showSuccessWindow from '../../../common/components/successPopup/successPopup';
import { successSendMessage } from '../../components/Feedback/popup/success';
import { message } from 'antd';

function* sendMessageFeedbackSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(sendMessageRequest, payload);

    if (response) {
      yield put(feedbackActions.sendMessageFeedbackSuccess(response));
      showSuccessWindow(successSendMessage);
    }
  } catch (error) {
    message.error('Ошибка отправки сообщения');
    yield put(feedbackActions.sendMessageFeedbackError(error));
  }
}

export function* feedbackConfigWatcher() {
  yield takeEvery(
    feedbackActions.sendMessageFeedback.toString(),
    sendMessageFeedbackSaga
  );
}
